import dataService from '../../data/data.service';


const actions = {
  
  add(context, signUp) {
    return new Promise(resolve => {
      dataService.modules.signups.add(signUp).then(id => {
        resolve()
      });
    });
  },
}

const mutations = {
 
}

export default {
  namespaced: true,
  actions,
  mutations
}